import { render, staticRenderFns } from "./hntyx.vue?vue&type=template&id=28d86936&"
import script from "./hntyx.vue?vue&type=script&lang=js&"
export * from "./hntyx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports